export const API_ERROR_CODES = {
  NotAuthenticated: 'NotAuthenticated',
  InvalidParameters: 'InvalidParameters',
  PermissionDenied: 'PermissionDenied',
  InternalServerError: 'InternalServerError',
  ResourceNotFound: 'ResourceNotFound',
  AlbumIllustLimitExceeded: 'AlbumIllustLimitExceeded',
  InvalidAlbumId: 'InvalidAlbumId',
  InvalidIllustId: 'InvalidIllustId',
  AlbumIllustAlreadyAdded: 'AlbumIllustAlreadyAdded',
  InvalidAlbumName: 'InvalidAlbumName',
  InvalidAlbumVisibility: 'InvalidAlbumVisibility',
  InvalidIllustOrder: 'InvalidIllustOrder',
  InvalidAlbumOrder: 'InvalidAlbumOrder',
  InvalidUserId: 'InvalidUserId',
  InvalidPage: 'InvalidPage',
  AlbumLimitExceeded: 'AlbumLimitExceeded',
  PasswordRequired: 'PasswordRequired',
  LoginAttemptsExceeded: 'LoginAttemptsExceeded',
  InvalidCredentials: 'InvalidCredentials',
  AccountDeleted: 'AccountDeleted',
  MessageRejected: 'MessageRejected',
  ProfileRejected: 'ProfileRejected',
  CommentTooLong: 'CommentTooLong',
  CommentLimitExceeded: 'CommentLimitExceeded',
  CommentRejected: 'CommentRejected',
  PinnedIllustLimitExceeded: 'PinnedIllustLimitExceeded',
  ImageRequired: 'ImageRequired',
  InvalidImage: 'InvalidImage',
  InvalidImageContent: 'InvalidImageContent',
  TitleRequired: 'TitleRequired',
  CommentNotFound: 'CommentNotFound',
  IllustNotFound: 'IllustNotFound',
  IllustUpdateFailed: 'IllustUpdateFailed',
  SignoutFailed: 'SignoutFailed',
  TagRequired: 'TagRequired',
  PopularTagsFetchFailed: 'PopularTagsFetchFailed',
  InvalidRequestId: 'InvalidRequestId',
  InvalidStatus: 'InvalidStatus',
  InvalidAwarenessType: 'InvalidAwarenessType',
  CommentRequired: 'CommentRequired',
  UserCommentTooLong: 'UserCommentTooLong',
  AdminCommentTooLong: 'AdminCommentTooLong',
  SuspensionRequestNotFound: 'SuspensionRequestNotFound',
  SuspensionRequestAlreadyResumed: 'SuspensionRequestAlreadyResumed',
  SuspensionRequestNotApproved: 'SuspensionRequestNotApproved',
  SuspensionResumeUnavailable: 'SuspensionResumeUnavailable',
  SuspensionRequestUnavailable: 'SuspensionRequestUnavailable',
  SuspendedUserOnly: 'SuspendedUserOnly',
  OpenSuspensionRequestOnly: 'OpenSuspensionRequestOnly',
  UserNotFound: 'UserNotFound'
} as const

export type ApiErrorCode = typeof API_ERROR_CODES[keyof typeof API_ERROR_CODES]

export interface ApiErrorResponse {
  error: ApiErrorCode
}
